import React, { useEffect, useState } from "react";
import { useSearchParams, Link } from "react-router-dom";
import api from "@/lib/api";
import { Button } from "@/components/ui/button";

export default function Unsubscribe() {
  const [params] = useSearchParams();
  const e = params.get("e") || "", t = params.get("t") || "";
  const [state, setState] = useState("loading");
  const [email, setEmail] = useState("");

  useEffect(() => {
    api.get("/unsubscribe", { params: { e, t } })
      .then(({ data }) => { setEmail(data.email); setState(data.opted_out ? "done" : "ready"); })
      .catch(() => setState("invalid"));
  }, [e, t]);

  const confirm = async () => {
    try { await api.post("/unsubscribe", { e, t }); setState("done"); } catch { setState("invalid"); }
  };

  return (
    <div className="min-h-screen bg-[#FDFDFD] flex items-center justify-center p-6" data-testid="unsubscribe-page">
      <div className="max-w-md w-full border-2 border-[#0F1F2E] bg-white p-8 space-y-4">
        <div className="text-[10px] font-semibold tracking-[0.24em] uppercase text-[#25AAAA]">iTeams · University of Essex</div>
        {state === "loading" && <p className="text-sm">Checking your link…</p>}
        {state === "invalid" && <p className="text-sm text-[#A23232]" data-testid="unsubscribe-invalid">This link isn't valid. Please use the link from a recent iTeams email, or stop emails from your dashboard.</p>}
        {state === "ready" && (
          <>
            <h1 className="font-display text-2xl font-black tracking-tighter">Stop programme emails?</h1>
            <p className="text-sm text-[#525252]">We'll stop emailing <strong>{email}</strong> about iTeams — team announcements, session details, surveys and attendance follow-ups. The programme team will see this and may contact you another way.</p>
            <Button onClick={confirm} className="w-full rounded-none bg-[#0F1F2E] hover:bg-[#1a2f42]" data-testid="unsubscribe-confirm">Stop programme emails</Button>
          </>
        )}
        {state === "done" && (
          <>
            <h1 className="font-display text-2xl font-black tracking-tighter" data-testid="unsubscribe-done">You're unsubscribed</h1>
            <p className="text-sm text-[#525252]">{email} will no longer receive iTeams emails. Changed your mind? Sign in and turn them back on from your dashboard.</p>
          </>
        )}
        <Link to="/privacy" className="text-xs text-[#25AAAA] underline">Privacy notice</Link>
      </div>
    </div>
  );
}
